(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    const restoreCard = () => {
      let id = url.hash.slice(1);
      try { id = decodeURIComponent(id); } catch {}
      document.getElementById(id)?.scrollIntoView({ behavior: 'auto', block: 'start' });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restoreCard, {once:true});
    else restoreCard();
  }

  } catch(e) { console.error(e); }
})();
})();
